import { MdOutlineFormatAlignJustify } from "react-icons/md";
import { apiGet, apiPost, apiPut, apiDelete, apiPostWithMultiPart, apiPatch } from "../utils/axios";
import { domainUrl } from "../utils/domainUrls";


export const physicianService = {
  // Get all physicians
  getAll: (size = 50, current = 1, searchInput = "", sortColumn = "", filterTab = JSON.stringify([])) => apiGet(domainUrl(`/v1/users/physicians?name=${encodeURIComponent(searchInput)}&limit=${size}&page=${current}&sortBy=${sortColumn}&specialty=${encodeURIComponent(filterTab)}`)),

  // Get physician by ID
  getById: (userId) => apiGet(domainUrl(`/v1/users/physicians/${userId}`)),

  // Create new physician
  create: (payload) => apiPost(domainUrl('/v1/users/physicians'), payload),

  // Update physician
  update: (userId, payload) => apiPut(domainUrl(`/v1/users/physicians/${userId}`), payload),

  // Delete physician
  delete: (userId) => apiDelete(domainUrl(`/v1/users/physicians/${userId}`)),

  // Get Non boardMember physicians
  getNonBoardMemberPhysician: () => apiGet(domainUrl(`/v1/users/non-board-members`)),

  handleConsentAccept: (userId, payload) => apiPatch(domainUrl(`/v1/users/accept-consent/${userId}`), payload),
  // get user data
  getMyProfile: () => apiGet(domainUrl(`/v1/users/get-my-profile`)),

  // Update user data
  updateMyProfile: (id, payload) => apiPatch(domainUrl(`/v1/users/update-my-profile/${id}`), payload),

  // Upload file
  uploadFile: (payload) => apiPost(domainUrl(`/v1/users/import-physician`), payload),

  // Preview import
  previewImport: (payload) => apiPostWithMultiPart(domainUrl(`/v1/users/preview-import`), payload),
};


export const patientService = {
  // Get all patients
  getAll: (size = 7, current = 1, searchInput = "", sortColumn = "", physician = "", ccm = "") => apiGet(domainUrl(`/v1/users/patient?limit=${size}&page=${current}&sortBy=${sortColumn}&name=${encodeURIComponent(searchInput)}&physician=${physician}&ccm=${ccm}`)),

  // Get patient by ID
  getById: (userId) => apiGet(domainUrl(`/v1/users/patient/${userId}`)),

  // Update patient
  update: (userId, payload) => apiPut(domainUrl(`/v1/users/patient/${userId}`), payload),

  // Delete patient
  delete: (userId) => apiDelete(domainUrl(`/v1/users/patient/${userId}`)),

  // Create patient
  create: (payload) => apiPost(domainUrl('/v1/users/patient'), payload),
};


export const adminService = {
  // Get all admins
  getAll: () => apiGet(domainUrl('/v1/users/admin')),

  // Get admin by ID
  getById: (userId) => apiGet(domainUrl(`/v1/users/admin/${userId}`)),

  // Create new admin
  create: (payload) => apiPost(domainUrl('/v1/users/admin'), payload),

  // Update admin
  update: (userId, payload) => apiPut(domainUrl(`/v1/users/admin/${userId}`), payload),

  // Delete admin
  delete: (userId) => apiDelete(domainUrl(`/v1/users/admin/${userId}`))
};


export const libraryManagerService = {
  // Get all library managers
  getAll: (size = 7, currentPage = 1, searchInput = "", sortColumn = "") => apiGet(domainUrl(`/v1/users/library-manager?limit=${size}&page=${currentPage}&sortBy=${sortColumn}&name=${encodeURIComponent(searchInput)}`)),

  // Get library manager by ID
  getById: (userId) => apiGet(domainUrl(`/v1/users/library-manager/${userId}`)),

  // Create new library manager
  create: (payload) => apiPost(domainUrl('/v1/users/library-manager'), payload),

  // Update library manager
  update: (userId, payload) => apiPut(domainUrl(`/v1/users/library-manager/${userId}`), payload),

  // Delete library manager
  delete: (userId) => apiDelete(domainUrl(`/v1/users/library-manager/${userId}`))
};

export const assistantService = {
  // Get all assistants
  getAll: (size = 7, currentPage = 1, searchInput = "", sortColumn = "") => apiGet(domainUrl(`/v1/users/assistant?limit=${size}&page=${currentPage}&name=${encodeURIComponent(searchInput)}&sortBy=${sortColumn}`)),

  // Get assistant by ID
  getById: (userId) => apiGet(domainUrl(`/v1/users/assistant/${userId}`)),

  // Create new assistant
  create: (payload) => apiPost(domainUrl('/v1/users/assistant'), payload),

  // Update assistant
  update: (userId, payload) => apiPut(domainUrl(`/v1/users/assistant/${userId}`), payload),

  // Delete assistant
  delete: (userId) => apiDelete(domainUrl(`/v1/users/assistant/${userId}`))
}

export const ccmManagerService = {
  // Get all CCM managers
  getAll: (size = 7, currentPage = 1, searchInput = "", sortColumn = "") => apiGet(domainUrl(`/v1/users/ccm-manager?limit=${size}&page=${currentPage}&name=${encodeURIComponent(searchInput)}&sortBy=${sortColumn}`)),

  // Get CCM manager by ID
  getById: (userId) => apiGet(domainUrl(`/v1/users/ccm-manager/${userId}`)),

  // Create new CCM manager
  create: (payload) => apiPost(domainUrl('/v1/users/ccm-manager'), payload),

  // Update CCM manager
  update: (userId, payload) => apiPut(domainUrl(`/v1/users/ccm-manager/${userId}`), payload),

  // Delete CCM manager
  delete: (userId) => apiDelete(domainUrl(`/v1/users/ccm-manager/${userId}`))
}

export const ccmCoordinatorService = {
  // Get all CCM coordinators
  getAll: (size = 7, currentPage = 1, searchInput = "", sortColumn = "", filterTab = JSON.stringify([])) => apiGet(domainUrl(`/v1/users/ccm-coordinator?limit=${size}&page=${currentPage}&name=${encodeURIComponent(searchInput)}&sortBy=${sortColumn}&specialty=${encodeURIComponent(filterTab)}`)),

  // Get CCM coordinator by ID
  getById: (userId) => apiGet(domainUrl(`/v1/users/ccm-coordinator/${userId}`)),

  // Create new CCM coordinator
  create: (payload) => apiPost(domainUrl('/v1/users/ccm-coordinator'), payload),

  // Update CCM coordinator
  update: (userId, payload) => apiPut(domainUrl(`/v1/users/ccm-coordinator/${userId}`), payload),

  // Delete CCM coordinator
  delete: (userId) => apiDelete(domainUrl(`/v1/users/ccm-coordinator/${userId}`))
}



export default {
  physician: physicianService,
  patient: patientService,
  admin: adminService,
  libraryManager: libraryManagerService,
  assistant: assistantService,
  ccmManager: ccmManagerService,
  ccmCoordinator: ccmCoordinatorService,
};